import { apiClient } from "@/services/api/axiosClient";
import type { ApiResponse } from "@/services/api/api.types";
import { API_ENDPOINTS } from "@/services/api/endpoints";

export type SubmitHomesteadDocumentsRequest = {
  property_id: string;
  signature: string;
};

export interface SubmitHomesteadDocumentsResponse {
  homestead_document_url?: string | null;
  exemption_document_url?: string | null;
  homesteadSignedAt?: string;
}

export type UploadLicensePhotoPayload = {
  property_id: string;
  documentType: string;
  documentSide: string;
  file: File | { uri: string; name: string; type: string };
};

const HOME_STEAD_DOCUMENT_ENDPOINT = API_ENDPOINTS.PROPERTY.HOMESTEAD_EXEMPTION_SIGN;
const HOME_STEAD_LICENSE_PHOTO_ENDPOINT = API_ENDPOINTS.PROPERTY.HOMESTEAD_DOCUMENTS;

export const submitHomesteadDocuments = async (
  payload: SubmitHomesteadDocumentsRequest
): Promise<ApiResponse<SubmitHomesteadDocumentsResponse>> => {
  const { data } = await apiClient.post<ApiResponse<SubmitHomesteadDocumentsResponse>>(
    HOME_STEAD_DOCUMENT_ENDPOINT,
    payload
  );
  return data;
};

export const uploadHomesteadLicensePhoto = async (
  payload: UploadLicensePhotoPayload
): Promise<ApiResponse<unknown>> => {
  const formData = new FormData();
  formData.append("property_id", payload.property_id);
  formData.append("document_type", payload.documentType);
  formData.append("document_side", payload.documentSide);
  if (payload.file instanceof File) {
    formData.append("file", payload.file);
  } else {
    formData.append("file", {
      uri: payload.file.uri,
      name: payload.file.name,
      type: payload.file.type,
    } as unknown as Blob);
  }

  const { data } = await apiClient.post<ApiResponse<unknown>>(
    HOME_STEAD_LICENSE_PHOTO_ENDPOINT,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return data;
};
